import { faCheckCircle } from '@fortawesome/pro-duotone-svg-icons'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import customConfig from 'customConfig'
import { containsNoValues } from 'src/util/object.helpers'
import {
  checkValidations,
  requiredRule
} from 'src/util/validation/commonValidation.helpers'
import CancelListing from '../components/nfts/CancelListing'
import NftDetails from '../components/nfts/NftDetails'
import Nfts from '../components/nfts/Nfts'
import SellNft from '../components/nfts/SellNft'
import TransferNft from '../components/nfts/TransferNft'
import SomethingWentWrong from '../components/popups/common/SomethingWentWrong'
import Popup from '../components/shared/popup/Popup'
import { DEFAULT_CONTAINER_STATE } from '../constants/containerStates'
import { NFT_ACTIONS_STEPS } from '../constants/nft'
import { COLOR_SUCCESS } from '../constants/theme'
import {
  cancelNftListing,
  // changeNftActionState,
  changeNftPopupState,
  changeSellNftInputAndErrorState,
  changeSellNftState,
  changeTransferNftInputAndErrorState,
  changeTransferNftState,
  getListedNftById,
  getNftBalances,
  getNftClaims,
  getNftExclusiveContent,
  getNftsListedForSale,
  listNftForSale,
  resetNftsState,
  resetSellNftState,
  resetTransferNftState,
  transferNft
} from '../store/actions/nft'
import { SELL_NFTS_PROFILE_DISPATCH } from '../store/reducers/nft/sellNft'
import { TRANSFER_NFTS_PROFILE_DISPATCH } from '../store/reducers/nft/transferNft'

const NftsContainer = ({
  transferNftProfile,
  sellNftProfile,
  changeTransferNftState,
  changeTransferNftInputAndErrorState,
  resetTransferNftState,
  tokenProfile,
  resetSellNftState,
  changeSellNftInputAndErrorState,
  changeSellNftState,
  listNftForSale,
  getListedNftById,
  cancelNftListing,
  // changeNftActionState,
  changeNftPopupState,
  nftProfile,
  transferNft,
  resetNftsState,
  getNftClaims,
  getNftExclusiveContent,
  getNftBalances
}) => {
  const { t } = useTranslation()
  const [nft, setNft] = useState()
  const [sellNftDetails, setSellNftDetails] = useState({})
  const {
    nfts,
    nftActionState,
    nftPopupState,
    nftForSale,
    nftClaimCount,
    // loading,
    loadingNftBalance
  } = nftProfile

  useEffect(() => {
    getNftBalances()
  }, [])

  useEffect(() => {
    if (nft) {
      const nftId = nft.nftId
      getListedNftById(nftId, nft.id)
      getNftClaims(nftId, nft.id)
      if (nft.nftUrl) {
        getNftExclusiveContent(nft.nftUrl)
      }
    }
  }, [nft])

  useEffect(() => {
    const action = nftPopupState
    if (action) {
      buildSuccessPopup(action)
    } else {
      handleNoNftActionPopup()
    }
  }, [nftPopupState])

  useEffect(() => {
    if (sellNftProfile.stopSaleDisabled) {
      setTimeout(
        () =>
          changeSellNftState(
            SELL_NFTS_PROFILE_DISPATCH.STOP_SALE_DISABLED,
            false
          ),
        20000
      )
    }
  }, [sellNftProfile.stopSaleDisabled])

  const [popupState, setPopupState] = useState(DEFAULT_CONTAINER_STATE.NONE)
  const [rootPopup, setRootPopup] = useState(DEFAULT_CONTAINER_STATE.NONE)

  const buildSuccessPopup = (action) => {
    setPopupState(action)
  }

  const handleNftActionSelect = (action) => {
    changeNftPopupState(action)
  }

  const handleSellNft = (nftId, tokenId, usdPrice) => {
    const errors = checkValidations({
      numberOfPoints: {
        value: sellNftProfile.numberOfPoints,
        rules: [requiredRule]
      }
    })
    if (containsNoValues(errors)) {
      setSellNftDetails({ nftId, tokenId, usdPrice })
      setPopupState(NFT_ACTIONS_STEPS.CONFIRM_SELL)
    } else {
      changeSellNftState(SELL_NFTS_PROFILE_DISPATCH.ERROR, errors)
    }
  }

  const handleSelectNft = (selectedNft) => {
    setNft(selectedNft)
    setRootPopup(NFT_ACTIONS_STEPS.NFT_DETAILS)
  }

  const handleNoPopup = () => {
    setNft(null)
    resetNftsState()
    setRootPopup(DEFAULT_CONTAINER_STATE.NONE)
  }

  const handleNoNftActionPopup = () => {
    setPopupState(DEFAULT_CONTAINER_STATE.NONE)
    changeNftPopupState('')
  }

  const renderPopup = () => {
    switch (rootPopup) {
      case NFT_ACTIONS_STEPS.NFT_DETAILS:
        return (
          <NftDetails
            onCancel={handleNoPopup}
            t={t}
            onNftActionSelect={handleNftActionSelect}
            nftClaimCount={nftClaimCount}
            cancelListingAction={
              nftActionState === NFT_ACTIONS_STEPS.CANCEL_LISTING && (
                <CancelListing
                  t={t}
                  onCancelListing={handleCancelListing}
                  nftForSale={nftForSale}
                  sellNftProfile={sellNftProfile}
                  tokenProfile={tokenProfile}
                  loading={nftProfile.listingLoading}
                />
              )
            }
            // loading={loading}
            nftProfile={nftProfile}
            {...nft}
          />
        )

      default:
        break
    }
  }

  const handlePopupSubmit = () => {
    switch (popupState) {
      case NFT_ACTIONS_STEPS.CONFIRM_TRANSFER:
        transferNft(nft.id, transferNftProfile.accountNumber, nft.nftId)
        break

      case NFT_ACTIONS_STEPS.TRANSFER_CONFIRMED:
        resetTransferNftState()
        handleNoNftActionPopup()
        break

      case NFT_ACTIONS_STEPS.CONFIRM_SELL:
        const { nftId, tokenId, usdPrice } = sellNftDetails
        listNftForSale(nftId, tokenId, usdPrice)
        break

      case DEFAULT_CONTAINER_STATE.SOMETHING_WENT_WRONG:
        handleNoNftActionPopup()
        break

      case NFT_ACTIONS_STEPS.TRANSFER:
        const errors = checkValidations({
          accountNumber: {
            value: transferNftProfile.accountNumber,
            rules: [requiredRule]
          }
        })
        if (containsNoValues(errors)) {
          setPopupState(NFT_ACTIONS_STEPS.CONFIRM_TRANSFER)
        } else {
          changeTransferNftState(TRANSFER_NFTS_PROFILE_DISPATCH.ERROR, errors)
        }
        break

      default:
        break
    }
  }

  const handlePopupCancel = () => {
    switch (popupState) {
      case NFT_ACTIONS_STEPS.TRANSFER:
        resetTransferNftState()
        handleNoNftActionPopup()
        break

      case NFT_ACTIONS_STEPS.SELL:
        resetSellNftState()
        handleNoNftActionPopup()
        break

      default:
        handleNoNftActionPopup()
        break
    }
  }

  const handleCancelListing = () => {
    const orderId = nftForSale?.orderId
    if (orderId) {
      cancelNftListing(orderId)
    }
  }

  const renderNftActionPopup = () => {
    switch (popupState) {
      case NFT_ACTIONS_STEPS.CONFIRM_TRANSFER:
        return (
          <Popup
            title={t('nft.transfer-confirmation')}
            description={t('nft.transfer-confirmation-desc', {
              nftName: nft?.name,
              accountNumber: transferNftProfile.accountNumber
            })}
            icon={customConfig.nftIcon}
            cancelLabel={t('common.go-back')}
            onCancel={handlePopupCancel}
            submitLabel={t('common.confirm')}
            onFormSubmit={handlePopupSubmit}
            submitBtnProps={{
              loading: transferNftProfile.loading
            }}
          />
        )

      case NFT_ACTIONS_STEPS.TRANSFER_CONFIRMED:
        return (
          <Popup
            title={t('nft.transfer-successful')}
            description={t('nft.transfer-successful-desc', {
              nftName: nft?.name
            })}
            icon={faCheckCircle}
            color={COLOR_SUCCESS}
            submitLabel={t('common.awesome')}
            onFormSubmit={handlePopupSubmit}
            submitBtnProps={{
              loading: transferNftProfile.loading
            }}
            onCancel={handlePopupCancel}
          />
        )

      case NFT_ACTIONS_STEPS.CONFIRM_SELL:
        return (
          <Popup
            title={t('nft.sell-confirmation')}
            description={t('nft.sell-confirmation-desc', {
              nftName: nft?.name,
              points: sellNftProfile.numberOfPoints,
              symbol: tokenProfile.symbol
            })}
            icon={customConfig.nftIcon}
            cancelLabel={t('common.go-back')}
            onCancel={handlePopupCancel}
            submitLabel={t('common.confirm')}
            onFormSubmit={handlePopupSubmit}
            submitBtnProps={{
              loading: sellNftProfile.loading
            }}
          />
        )

      case NFT_ACTIONS_STEPS.TRANSFER:
        return (
          <TransferNft
            t={t}
            dispatchAction={changeTransferNftInputAndErrorState}
            transferNftProfile={transferNftProfile}
            onFormSubmit={handlePopupSubmit}
            onCancel={handlePopupCancel}
            tokenName={tokenProfile.name}
          />
        )
      case NFT_ACTIONS_STEPS.SELL:
        return (
          <SellNft
            t={t}
            dispatchAction={changeSellNftInputAndErrorState}
            sellNftProfile={sellNftProfile}
            onFormSubmit={handleSellNft}
            onCancel={handlePopupCancel}
            tokenProfile={tokenProfile}
            {...nft}
          />
        )
      case DEFAULT_CONTAINER_STATE.SOMETHING_WENT_WRONG:
        return <SomethingWentWrong onSubmit={handlePopupSubmit} t={t} />

      default:
        break
    }
  }

  return (
    <>
      <Nfts
        t={t}
        loadingNftBalance={loadingNftBalance}
        onSelectNft={handleSelectNft}
        nfts={nfts}
      />
      {renderPopup()}
      {renderNftActionPopup()}
    </>
  )
}

const mapStateToProps = ({ nftReducer, mainReducer }) => {
  const { nftProfile, transferNftProfile, sellNftProfile } = nftReducer
  const { tokenProfile } = mainReducer
  return {
    transferNftProfile,
    sellNftProfile,
    tokenProfile,
    nftProfile
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeTransferNftState,
      changeTransferNftInputAndErrorState,
      changeSellNftInputAndErrorState,
      resetTransferNftState,
      resetSellNftState,
      changeSellNftState,
      listNftForSale,
      getNftsListedForSale,
      cancelNftListing,
      // changeNftActionState,
      changeNftPopupState,
      getListedNftById,
      transferNft,
      resetNftsState,
      getNftClaims,
      getNftExclusiveContent,
      getNftBalances
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(NftsContainer)
